import { formatDate } from '../../../helpers/format-date';
import articleType from '../../../helpers/article-type';
const eq = (a, b) => a === b;

<template>
  <div
    class='post-preview tiny negative no-img
      {{if (eq (articleType @article.__typename) "esports") "e-sport"}}
      {{if (eq (articleType @article.__typename) "news") "gaming-news"}}'
  >
    <p class='post-preview-title'>
      {{@article.title}}
    </p>
    <div class='post-author-info-wrap'>
      <p class='post-author-info small light'>
        By
        <span class='post-author'>{{@article.author.name}}</span>
        <span class='separator'>|</span>
        {{formatDate @article.publishedDate}}
      </p>
    </div>
  </div>
</template>

//game-review, gaming-news, e-sports
